// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0777cbe8","455":"d18bcc5a","879":"e53a8dab","977":"1557c75a"}[chunkId] + ".chunk.js";
};